// extracted by mini-css-extract-plugin
module.exports = {"root":"ShortStats_root__mP6SL","item":"ShortStats_item__tsBmH"};